import { apiSlice } from '../api/apiSlice';
import {
  GetRegionParams,
  GetRegionResponse,
  GetRegionsParams,
  GetRegionsResponse,
} from './regionApiSliceTypes';

const regionApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getRegions: builder.query<GetRegionsResponse, GetRegionsParams>({
      query: (params) => ({
        url: '/regions',
        method: 'GET',
        headers: {
          'Accept-Language': params.acceptLanguage ?? 'en',
        },
        params: {
          includeCountries: params.includeCountries,
        },
      }),
    }),

    getRegion: builder.query<GetRegionResponse, GetRegionParams>({
      query: (params) => ({
        url: `/regions/${params.id}`,
        method: 'GET',
        headers: {
          'Accept-Language': params.acceptLanguage ?? 'en',
        },
        params: {
          includeCountries: params.includeCountries,
        },
      }),
    }),
  }),

  overrideExisting: true,
});

export const {
  useGetRegionsQuery,
  useLazyGetRegionsQuery,
  useGetRegionQuery,
  useLazyGetRegionQuery,
} = regionApiSlice;
